<template>
  <div style="height: 100vh;;overflow-y:hidden;" :style="{'background':'linear-gradient(180deg, #22C9FE 0%, #0172F2 100%)'}"> 
    <div class="machine-head" style="font-size:60px;letter-spacing:10px;height:120px;line-height:120px;
  text-shadow: 2px 2px 0 #000, -2px -2px 0 #000, 2px -2px 0 #000, -2px 2px 0 #000;position:relative" :style="{'color':'#fff','background':'#ea0000'}">
      <img style="width:100px;margin-right:10px;  ; position: absolute;" src="https://wa.ccachina.net/img/logo.58b57af4.png" /> 
      <div style=" text-align:center">{{ row.title }}
        出场顺序
      </div>
        <img style="width:100px;position: absolute; float:right;top:20px;right:20px" src="https://wa.ccachina.net/img/logo.58b57af4.png" /> 
      <!-- <div>{{ row.saiqu_name }}</div> -->
    </div>
    <div style="background-image: linear-gradient(#f9f400 0%, #f9f400 48%, #f9f400 100%);
    height: 100px;
    letter-spacing:0.2em; 
  text-shadow: 2px 2px 0 white, -2px -2px 0 white, 2px -2px 0 white, -2px 2px 0 white;
    line-height: 100px;
    margin: 10px;
    text-align: center;
    color: #000;
    font-size: 50px;
    padding: 0px 20px;
    font-weight: bold;
    ">{{row.saiqu_name}}</div>

    <table class="machine-table"  style="margin:10px; background-image: linear-gradient(180deg, #002CDA 0%, #011C9D 48%, #002CDA 100%);"  :style="'overflow-y: auto;' ">
      <thead :style="{'background':'#011fa7','color':row.show_font_color_2}">
      <tr>
        <th>次序</th>
        <th>项目名称</th>
        <th>队伍名称</th>
<!--        <th>状态</th>-->
<!--        <th>操作</th>-->
      </tr>
      </thead>
      <tbody :style="'height:100%;overflow-y: scroll;' ">
      <tr v-for="(item, index) in list" :key="item.id" :style="{'color':row.show_font_color_2 ,'background':index%2==0?'#2143dd':'#011fa7'}">
        <td>{{ index + 1 }}</td>
        <td>{{ item.subject_name }}</td>
        <td>{{ item.mingcheng }}</td>
<!--        <td>-->
<!--          <span v-if="item.status==1" style="color: white">等待打分</span>-->
<!--          <span v-else-if="item.status==2">打分完成</span>-->
<!--          <span v-else-if="item.status==3" style="color: red">比赛弃权</span>-->
<!--          <span v-else>进行中</span>-->
<!--        </td>-->
<!--        <td>-->
<!--          <a @click="handleOpenArmy(item)">队伍信息</a>-->
<!--          <a-divider type="vertical"/>-->
<!--          <a @click="handleOpenRank(item)">分数</a>-->
<!--          <a-divider type="vertical"/>-->
<!--          <a @click="handleOpenSubjectRank(item)">项目排名</a>-->
<!--        </td>-->
      </tr>
      </tbody>

    </table>
  </div>
</template>
<style scoped>
body {
  overflow-y: hidden;
}

.machine-table {
  /* width: 100%; */
  /* color: #E3E59D; */
}

table th, table td {
  height: 80px;
  font-size: 32px;
  /*text-align: center;*/
  /*border: 1px solid gray;*/
}
::-webkit-scrollbar {
  width: 0px;
  /*background-color: transparent;*/
}

table td a {
  color: #E3E59D;
}

table td a:hover {
  color: #F2EB92;
  text-decoration: underline;
}

table td a.disabled {
  color: #999;
}

table td a.disabled:hover {
  cursor: default;
  text-decoration: none;
}

table thead {
  /* color: white; */
  /* background-color: #0782B8; */
}

table tbody {
  display: block;
  /*width: calc(100% + 8px); !*这里的8px是滚动条的宽度*!*/
  height: 300px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

table thead tr, table tbody tr, table tfoot tr {
  box-sizing: border-box;
  table-layout: fixed;
  display: table;
  width: 100%;
}

table thead th:first-child {
  width: 100px;
  text-align: center;
}

table tbody td:first-child {
  text-align: center;
  width: 100px;
}

table thead th:nth-child(2) {
  text-align: left;
  width: 400px;
}

table tbody td:nth-child(2) {
  width: 400px;
}

table thead th:nth-child(3) {
  text-align: left;
  width: 360px;
}

table tbody td:nth-child(3) {
  width: 360px;
}

/*table thead th:nth-child(4) {*/
/*  width: 100px;*/
/*}*/

/*table tbody td:nth-child(4) {*/
/*  width: 100px;*/
/*}*/

/*table thead th:first-child, table tbody td:first-child{*/
/*  padding-left: 30px;*/
/*}*/

table tr:nth-child(even) {
  /* background: #0782B8; */
}

.pointer {
  cursor: pointer;
}


.machine-head {
  /*background: url("../../assets/icon-machine-bg.png") no-repeat;*/
  /*background-size: 100% 205px;*/
  /*height: 205px;*/
  padding: 13px 20px;
  text-align: left;
  font-size: 36px;
  /* color: #fff; */
  font-weight: bold;
}

.machine-content {
  margin: 30px 30px 0;
}

.machine-content-left {
  width: 75%;
}

.machine-content-operate {
  display: flex;
  flex-wrap: wrap;
}

.machine-li {
  width: 20%;
  text-align: center;
}

.machine-li-box {
  margin: 0 10px 10px 0;
  background: #fff;
  overflow: hidden;
  border-radius: 10px;
}

.caipan-info {
  padding: 10px 0;
  cursor: pointer;
}

.caipan-info-disabled {
  background: #EEEEEE;
}

.caipan-name {
  font-weight: 500;
  color: #4A4A4A;
}

.caipan-score {
  font-size: 30px;
  font-weight: 500;
  color: #000;
  font-family: DINAlternate-Bold, DINAlternate;
}

.caipan-comment {
  color: #9B9B9B;
}

.flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.flex-start {
  display: flex;
  justify-content: flex-start;
}

.flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.caipan-button {
  padding: 0 5px;
  height: 35px;
  width: 100%;
}

.caipan-button-active {
  background: #1F85E2;
}

.caipan-button-score {
  background: #0EB791;
  cursor: pointer;
}

.caipan-button-disabled {
  background: #9B9B9B;
}

.caipan-button-li {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 12px;
  height: 35px;
  cursor: pointer;
  color: #fff;
}

.caipan-machine-li {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 12px;
  color: #fff;
  height: 35px;
  cursor: pointer;
}

.caipan-button-li img, .caipan-machine-li img {
  width: 14px;
  margin-right: 5px;
}

</style>
<script>
export default {
  name: 'ScoreStartList',
  components: {
  },
  props: {
    row: {
      type: Object,
      default: () => {}
    },
    list: {
      type: Array,
      default:[]
    }
  },
  data() {
    return {
      loading: false,
      saveLoading: false,
      drawerVisible: false,
      scoreVisible: false,
      rankVisible: false,
      dataVisible: false, // 修改数据
      currentFilter: false,
      currentCpIndex: 0, 

      queryParam: {
        keywords: '',
        showScore: 1, // 只显示有分数的
        subjectRow: '',
        sjsq: [],
      },

      dataColumns: [],
      clientHeight: 0
    }

  },
  mounted() {
    const that = this

    // 获取浏览器可视区域高度
    this.clientHeight = `${document.documentElement.clientHeight}`          //document.body.clientWidth;

  },
  destroyed() {
  },
  computed: {},
  methods: {

  }
}
</script>



// WEBPACK FOOTER //
// ScoreStartList2.vue?42d061ca